import React, {Component, Fragment} from 'react'
import {message, Modal, Form, DatePicker, Tooltip} from 'antd'
import {getImportOrderShort, getImportOrderTimes,} from '../../api';
import {subTimeStr, subStr} from "../../utills/subStringUtill";
import './import-delivery-step.less'
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');

const formItemLayout = {
    labelCol: {
        span: 6,
    },
    wrapperCol: {
        span: 14,
    },
};
class ImportDeliveryStep extends Component {
    constructor(props) {
        super(props);
        this.state = {
            deliveryType: '',
            entrustType: '',
            record: [],
            processShow: false,
            visible: false,
            okBtn: false,
        }
    }

    componentDidMount() {
        const orderId = this.props.location.state.orderId;
        this.getOrderShortFunc(orderId);
        this.setState({orderId: orderId});
    }

    getOrderShortFunc = async (orderId) => {
        let result = await getImportOrderShort(orderId);
        if (result.code === 200) {
            this.setState({
                deliveryType: result.data.orderDo.deliveryType,
                entrustType: result.data.orderDo.entrustType,
            }, function () {
                this.getOptRecord(orderId);
            })
        } else if (result.code === 401) {
            this.props.history.replace('/login')
        } else {
            message.error(result.message)
        }
    };
    getOptRecord = async (orderId) => {
        const result = await getImportOrderTimes(orderId);
        if (result.code === 200) {
            const data = {};
            for (let d of result.data) {
                data[d.optType] = d.optDt;
            }
            // 转关服务第二点隐藏
            if (this.state.entrustType === 'p2d'){
                result.data.splice(1, 0, {});
            }
            result.data.splice(2, 0, {});
            this.setDivs(result.data);
            this.setState(data);
        }
    };
    setDivs = (steps, optType, optDt) => {
        if (optType) {
            //时间新增 修改 删除时改变state值
            for (let s of steps) {
                if (s.optType === optType) {
                    Object.assign(s, {optType, optDt});
                    break;
                }
            }
        }
        const divs = (steps || []).map(d => {
                const step = <Fragment>
                    <div className="circle"><i></i></div>
                    <div className="title">{d.optName}</div>
                    <div className="time1">{d.optDt ? subStr(d.optDt) : ''}</div>
                    <div className="time2">{d.optDt ? subTimeStr(d.optDt) : ''}</div>
                </Fragment>;
                  let className = 'info';
                if (className === 'info') {
                    return <div className={d.optDt ? 'proceIteam finish' : 'proceIteam'}>
                        <Tooltip title="不可编辑">
                            <div className={className}>{step}</div>
                        </Tooltip>
                    </div>
                }
                return <div className={d.optDt ? 'proceIteam finish' : 'proceIteam'}>
                    <div className={className}
                         onClick={() => this.editDate(d.optType, d.optDt, className === 'info itemHover')}>
                        {step}
                    </div>
                </div>
            }
        );
        this.setState({divs, steps})
    };
    spreadOpt = () => {
        const {processShow} = this.state;
        if (processShow) {
            this.setState({processShow: false})
        } else {
            this.setState({processShow: true})
        }
    };

    render() {
        const {getFieldDecorator,} = this.props.form;
        const {processShow, divs, visible, commitDt, entrustType} = this.state;
        const className = entrustType === 'p2d' ? ' hide' : '';
        return (
            <div>
                <div className={processShow ? "processBox processShow" + className : 'processBox' + className}>
                    <Modal
                        title="轨迹编辑"
                        visible={visible}
                        okButtonProps={{disabled: this.state.okBtn}}>
                        <Form {...formItemLayout}>
                            <Form.Item label="时间">
                                {getFieldDecorator('optDt', {})(<DatePicker showTime format="YYYY-MM-DD HH:mm:ss"/>)}
                            </Form.Item>
                        </Form>
                    </Modal>
                    <div className={commitDt ? 'proceIteam finish' : 'proceIteam'}>
                        <Tooltip title="不可编辑">
                            <div className="info">
                                <div className="circle"><i></i></div>
                                <div className="title">货运订单</div>
                                <div className="time1">{commitDt ? subStr(commitDt) : ''}</div>
                                <div className="time2">{commitDt ? subTimeStr(commitDt) : ''}</div>
                            </div>
                        </Tooltip>
                    </div>
                    {divs}
                    <div className="processShowBtn" onClick={this.spreadOpt}><span className="open">展开</span> <span
                        className="closed">收起</span>
                    </div>
                </div>
            </div>
        )
    }
}
const DeliveryStepForm = Form.create()(ImportDeliveryStep);
export default DeliveryStepForm;